export const TABLE_HEADER_CLASSES = 'text-secondary fw-bolder font-18 text-nowrap';
export const LINK_CLASSES = 'text-blue-link hover-blue-hover text-decoration-none';

export const SECONDARY_COLOR = '#08090D';